<div class="header">
    <h2 mat-dialog-title>{{ 'locker.consumption.history.title' | translate }}</h2>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content>
    <div class="spirit-detail-locker-consumption-history-list">
        @for (consumption of consumptions | reverse; track consumption) {
            <div class="spirit-detail-locker-consumption-history-item">
                <span class="spirit-detail-locker-consumption-history-date">{{ consumption.createdAt | date: 'dd/MM/yyyy' }}</span>
                <div class="spirit-detail-locker-consumption-history-item-row">
                    <span>{{ 'locker.detail.quantity' | translate }}: {{ consumption.quantity }}</span>
                    <span>
                        {{ 'locker.detail.status' | translate }}:
                        <b>{{ ('locker.detail.status_' + consumption.status) | translate }}</b>
                        @if (consumption.status == 'partial') {
                            <b>({{ consumption.remainingQuantity }}%)</b>
                        }
                    </span>
                </div>
                @if (consumption.notes) {
                    <span class="spirit-detail-locker-consumption-history-notes">{{ consumption.notes }}</span>
                }
                @if (consumption.status == 'partial') {
                    <div class="spirit-detail-locker-consumption-history-actions">
                        <button mat-flat-button color="primary" (click)="finishConsumption(consumption)">{{ 'locker.consumption.history.finish' | translate }}</button>
                    </div>
                }
            </div>
        }
    </div>
</mat-dialog-content>